import { format } from 'date-fns';
import { SpreadsheetCell } from '@functions/export-spreadsheet';
import { ELeadOutcome, LeadResponse } from './services/responses/lead.response';
import { sourceLabel } from './formatters/lead-source-label';
import { CustomFieldResponse } from '@layouts/pages/Settings/general/custom-fields/services/responses/custom-field.response';
import {
    customFieldExportCell, exportedCustomFields,
} from '@layouts/pages/Settings/general/custom-fields/custom-field-value';

type Translate = (key: string) => string;

/// Data e hora no fuso de quem exporta, em formato que a planilha ordena (sem o "- 14:00h" da tela).
const dateTime = (value?: string | null) => (value ? format(new Date(value), 'dd/MM/yyyy HH:mm') : '');

/// "2026-09-30" vira 30/09/2026 sem Date, que voltaria um dia no fuso do Brasil.
const dateOnly = (value?: string | null) => {
    if (!value) return '';

    const [year, month, day] = value.split('-');
    return `${day}/${month}/${year}`;
};

const OUTCOME_KEY: Record<ELeadOutcome, string> = {
    [ELeadOutcome.Open]: 'desfecho.emAberto',
    [ELeadOutcome.Won]: 'desfecho.ganho',
    [ELeadOutcome.Lost]: 'desfecho.perdido',
};

/// Colunas da lista, o que não cabe na tela (e-mail, desfecho, perda) e campos personalizados.
export const leadExportRows = (
    leads: LeadResponse[],
    stageNames: Map<string, string>,
    t: Translate,
    customFields: CustomFieldResponse[] = [],
): SpreadsheetCell[][] => {
    const columns = exportedCustomFields(customFields, leads);

    return [
        [
            t('crmLista.lead'), t('people.telefone'), t('people.email'), t('crmLista.etapa'), t('crmLista.status'),
            t('crmLista.responsavel'), t('crmLista.valor'), t('exportar.valorFechado'), t('exportar.previsao'),
            t('exportar.desfecho'), t('exportar.motivoPerda'), t('crmLista.proximaAcao'), t('crmLista.ultimaMensagem'),
            t('crmLista.origem'), t('exportar.campanha'), t('crmLista.criadoEm'),
            ...columns.map((field) => field.name),
        ],
        ...leads.map((lead) => [
            lead.contactName,
            lead.contactPhone,
            lead.contactEmail ?? '',
            stageNames.get(lead.columnId) ?? '',
            lead.statusName,
            lead.assignedUserName ?? '',
            lead.value ?? null,
            lead.closedValue ?? null,
            dateOnly(lead.expectedCloseDate),
            t(OUTCOME_KEY[lead.outcome]),
            lead.lossReasonName ?? '',
            dateTime(lead.nextScheduledAt),
            dateTime(lead.lastMessageAt),
            sourceLabel(t, lead.source, lead.sourceDetail),
            lead.sourceCampaign ?? '',
            dateTime(lead.createdAt),
            ...columns.map((field) => customFieldExportCell(
                field,
                lead.customFieldValues?.find((value) => value.customFieldId === field.id)?.value,
                t,
            )),
        ]),
    ];
};
